import styles from './product-card.module.scss';
import React from "react";
import { Link } from "react-router-dom";

import CartButton from "../cart-button/cart-button";
import { Product } from "../../services/api";

export interface ProductCardProps {
  name?: string;
  classes?: string;
  product: Product;
}

/**
 * Tarjeta de producto — recicla el diseño de la tarjeta de receta
 * (`110:259`): contenedor navy, radio 30/30/30/200, portada, botón
 * "Ver producto", descripción, nombre y precio (que es un botón de carrito).
 */
export default class ProductCard extends React.Component<ProductCardProps> {
  static jsClass = "ProductCard";
  static defaultProps: Partial<ProductCardProps> = {
    name: "mbProductCard",
  };

  render(): React.ReactNode {
    const { classes, product } = this.props;
    if (!product) return null;

    return (
      <article className={styles['mb-product-card'] + (classes ? ' ' + classes : '')}>
        <img
          className={styles['mb-product-card__img']}
          src={product.imagen}
          alt={product.nombre}
          loading="lazy"
        />
        <div className={styles['mb-product-card__body']}>
          <Link className={styles['mb-product-card__btn']} to={`/productos/${product.slug}`}>
            Ver producto
          </Link>
          <p className={styles['mb-product-card__copy']}>{product.descripcion}</p>
          <h3 className={styles['mb-product-card__title']}>{product.nombre}</h3>
          <CartButton
            classes={styles['mb-product-card__price']}
            item={{
              slug: product.slug,
              nombre: product.nombre,
              precio: product.precio,
              unidad: product.unidad,
              imagen: product.imagen,
            }}>
            ${product.precio.toLocaleString("es-MX")} <small>por {product.unidad}</small>
          </CartButton>
        </div>
      </article>
    );
  }
}
